(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.FormsQuotes",
                {
                    url: "/FormsQuotes",
                    component: "formsquotes",
                    // requiredOnePermission: "AnnuityFormsQuotes:View|LifeFormsQuotes:View|LtcFormsQuotes:View",
                    PageTitle: "Forms And Quotes"
                });
        }
    ]);

    app.component("formsquotes",
        {
            templateUrl: "App/Tools/FormsQuotes/FormsQuotes.html",
            controller: formsQuotesCtrl,
            bindings: {

            }
        });

    formsQuotesCtrl.$inject = ["amplitudeService", "ssoApi", "permissionService", "externalLoading"];


    function formsQuotesCtrl(amplitudeService, ssoApi, permissionService, externalLoading) {

        var $ctrl = this;

        $ctrl.openExternalLink = function (link) {
            window.open(link);
        };

        this.ActivateRightBridgeSso = function () {
            if (permissionService.hasOnePermission("RightBridge:Access")) {
                var w = window.open();
                w.document.write(externalLoading.html);
                ssoApi.initiateRightBridgeSso().then(function (data) {
                    //console.log(data);
                    w.document.write(data);
                    w.document.forms.samlform.submit();
                },
                    function (error) {
                        w.document.write(" Failed.  There was an error accessing this resource.");
                    });
            }
        };

        this.ActivateCannexSso = function () {
            if (permissionService.hasOnePermission("Cannex:Access")) {
                var w = window.open();
                w.document.write(externalLoading.html);
                ssoApi.initiateCannexSso().then(function (data) {
                    //console.log(data);
                    w.document.write(data);
                    w.document.forms.cannex.submit();
                },
                    function (error) {
                        w.document.write(" Failed.  There was an error accessing this resource.");
                    });
            }
        };

        this.ActivateAnnuityRateWatchSso = function () {
            if (permissionService.hasOnePermission("AnnuityRateWatch:Access")) {
                var w = window.open();
                w.document.write(externalLoading.html);
                ssoApi.initiateAnnuityRateWatchSso().then(function (data) {
                    //console.log(JSON.parse(data.Result));              
                    w.location = JSON.parse(data.Result);
                },
                    function (error) {
                        w.document.write(" Failed.  There was an error accessing this resource.");
                    });
            }
        };
        this.ActivateIpipelineSso = function (rsid) {
            if (permissionService.hasOnePermission("IpipelineFormsQuotesAnnuity:Access|IpipelineFormsQuotesLife:Access|IpipelineFormsQuotesLtc:Access")) {
                //move window.open() to outside the async api call
                //needs to be in direct response to a user event (click) to not be blocked by popup blockers
                var w = window.open();
                w.document.write(externalLoading.html);
                ssoApi.initiateIpipelineSso(rsid).then(function (data) {
                    //console.log(data);
                    w.document.write(data);
                    w.document.forms.samlform.submit();
                },
                    function (error) {
                        w.document.write(" Failed.  There was an error accessing this resource.");
                    });
            }
        }

        this.ActivateLtcSelectSso = function () {
            if (permissionService.hasOnePermission("LtcSelect:Access")) {
                var w = window.open();
                w.document.write(externalLoading.html);
                ssoApi.initiateLtcSelectSso().then(function (data) {
                    //console.log(data);               
                    w.document.write(data);
                    w.document.forms.ltcselect.submit();
                },
                    function (error) {
                        w.document.write(" Failed.  There was an error accessing this resource.");
                    });
            }
        }

        this.ActivateAnnexusSso = function () {
            if (permissionService.hasOnePermission("AnnexusQuotes:Access")) {
                var w = window.open();
                w.document.write(externalLoading.html);
                ssoApi.initiateAnnexusSso().then(function (data) {
                    //console.log(data);               
                    w.document.write(data);
                    w.document.forms.samlform.submit();
                },
                    function (error) {
                        w.document.write(" Failed.  There was an error accessing this resource.");
                    });
            }
        }

        this.ActivateEnsightSso = function () {

            var w = window.open();
            w.document.write(externalLoading.html);
            ssoApi.initiateEnsightSso().then(function (data) {
                console.log(data);

                w.location = data;
            },
                function (error) {
                    w.document.write(" Failed.  There was an error accessing this resource.");
                });
        }

        $ctrl.logEvent = function (target) {
            amplitudeService.logClickEvent(target);
        };
    }

})(window.app, window.angular); // jshint ignore:line